import React from "react";
import "./PostsFromFilter.scss";

const options = [
  { value: "all", label: "All" },
  { value: "agency", label: "Agency" },
  { value: "agent", label: "Agents" },
];

const PostsFromFilter = ({ formik }: { formik: any }) => {
  return (
    <div className="posts-from-container">
      <p className="posts-from-title">Posts From</p>

      <div className="posts-from-options">
        {options.map((option) => (
          <label key={option.value} className="radio-label">
            <input
              type="radio"
              name="user_type"
              value={option.value}
              checked={formik.values.user_type === option.value}
              onChange={(e) =>
                formik.setFieldValue("user_type", e.target.value)
              }
            />
            <span className="custom-radio" />
            <span className="radio-text">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default PostsFromFilter;
